import React from 'react';
import { PropTypes } from 'prop-types';
import { NavLink } from 'react-router-dom';
import Svg from '@justgiving/svg';
import chevron from '@justgiving/icons/src/chevron-right-slim.svg';

const svg = <Svg markup={chevron} className="jg-icon--slim jg-pull-right" />;

const CustomNavLink = ({ path, name, isActive }) => (
  <NavLink
    to={path}
    isActive={isActive}
    activeClassName="nav__link--active"
    className="jg-space-psm jg-block jg-clearfix nav__link jg-color--empress jg-fill--empress"
  >
    <div
      className={`nav__link__text jg-pull-left qa-nav__link-${path.substring(
        1,
      )}`}
    >
      {name}
    </div>{' '}
    {svg}
  </NavLink>
);

CustomNavLink.propTypes = {
  path: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isActive: PropTypes.func,
};

CustomNavLink.defaultProps = {
  isActive: null,
};

export default CustomNavLink;
